import { render, staticRenderFns } from "./ModulesEmbed.vue?vue&type=template&id=2b3bd7ae"
import script from "./ModulesEmbed.vue?vue&type=script&lang=js"
export * from "./ModulesEmbed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports